import React, { useState } from "react";
import { Button, Modal } from "reactstrap";
import { blockCustomerByHId } from "../../../../redux/slices/transactionSlice";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../../helperFunctions";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";
import InputField from "../../Forms/InputField/InputField";

const BlockAllDetailsModal = (props) => {
    const { isOpen, onClose, browserId, onSuccess } = props;

    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [reason, setReason] = useState("");

    const dispatch = useDispatch();

    const handleClose = () => {
        setReason("");
        setIsButtonLoading(false);
        onClose();
    };

    const handleSubmit = async () => {
        try {
            setIsButtonLoading(true);
            let Payload = {
                browserId: browserId,
                reason: reason,
            };
            let response = await dispatch(blockCustomerByHId(Payload)).unwrap();
            responseToaster(response);
            if (!!response) {
                if (onSuccess) {
                    onSuccess();
                }
                handleClose();
            }
            setIsButtonLoading(false);
        } catch (err) {
            setIsButtonLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
            <div className="modal-header">
                <h3 className="modal-title mt-0">Block All Details</h3>
                <i onClick={handleClose} className="fa-solid fa-xmark"></i>
            </div>
            <div className="modal-body">
                <div>
                    <p>Are you sure you want to block all details?</p>
                </div>
                <div className="mb-3">
                    <InputField
                        label="Reason"
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter reason"
                    />
                </div>
            </div>
            <div className="modal-footer">
                <div className="d-flex justify-content-end button-space">
                    <Button className="graybutton" onClick={handleClose}>
                        Cancel
                    </Button>
                    <CustomeButton
                        className="submitbutton"
                        onClick={handleSubmit}
                        isButtonLoading={isButtonLoading}
                        disabled={reason === ""}
                    >
                        Submit
                    </CustomeButton>
                </div>
            </div>
        </Modal>
    );
};

export default BlockAllDetailsModal;
